import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState, ListStateItem, ListModuleItem} from '@/store/shared'
import CustomerSystemCode from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';
import ComboboxItem from '@/store/shared/entity/combobox-item';

interface SystemCodeState extends ListStateItem<CustomerSystemCode>{
    editSystemCode:CustomerSystemCode;
    categoryList: Array<any>;
    systemCode:Array<any>;
}
class SystemCodeModule extends ListModuleItem<SystemCodeState,any,CustomerSystemCode>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={

        editSystemCode:new CustomerSystemCode(),
        categoryList: [],
        systemCode:[],


    }

    actions={
        async getAll(context:ActionContext<SystemCodeState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('/services/app/SystemCode/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<CustomerSystemCode>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<SystemCodeState,any>,payload:any){
            await $http.post('services/app/SystemCode/Create',payload.data);
            let reponse=await $http.get('services/app/SystemCode/GetSystemCodeApi');
            context.state.systemCode = reponse.data.result;
        },
        async update(context:ActionContext<SystemCodeState,any>,payload:any){
            await $http.put('services/app/SystemCode/Update',payload.data);
            let reponse=await $http.get('services/app/SystemCode/GetSystemCodeApi');
            context.state.systemCode = reponse.data.result;
        },
        async delete(context:ActionContext<SystemCodeState,any>,payload:any){
            await $http.post('services/app/SystemCode/DeleteForAudit', payload.data);
            let reponse=await $http.get('services/app/SystemCode/GetSystemCodeApi');
            context.state.systemCode = reponse.data.result;
        },
        async getcustomersystemCode(context:ActionContext<SystemCodeState,any>,payload:any){
            let reponse=await $http.get('services/app/SystemCode/GetSystemCodeApi');
            context.state.systemCode = reponse.data.result;
            return reponse.data.result;
        },

        async get(context:ActionContext<SystemCodeState,any>,payload:any){
            let reponse=await $http.get('services/app/SystemCode/Get?Id='+payload.id);
            return reponse.data.result;
        },
    };
    overrideMutations={
        edit(state:SystemCodeState,data:CustomerSystemCode){
            state.editSystemCode=data;
        }
    }
}
const systemCodeModule=new SystemCodeModule();
export default systemCodeModule;